<template>
  <v-dialog :model-value="conflitos.length > 0" max-width="560" @update:model-value="!$event && $emit('fechar')">
    <v-card>
      <v-card-title class="text-wrap">Funcionário vinculado a outro setor</v-card-title>
      <v-card-text>
        <p class="mb-4">Feche primeiro o expediente no setor indicado para iniciar o funcionário neste setor.</p>
        <div v-for="conflito in conflitos" :key="`${conflito.id_funcionario}-${conflito.setor_id}`" class="mb-3">
          <strong>{{ conflito.funcionario_nome || `Funcionário ${conflito.id_funcionario}` }}</strong>
          <div>Setor: <strong>{{ conflito.setor_nome || `Setor ${conflito.setor_id}` }}</strong></div>
        </div>
        <p class="mb-0">É permitido trabalhar em várias ordens do mesmo setor.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="elevated" @click="$emit('fechar')">Entendi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { conflitos: { type: Array, default: () => [] } },
  emits: ['fechar'],
};
</script>
